import qs from 'query-string'

import getRequest from 'utils/getRequest'
import postRequest from 'utils/postRequest'

const path = '/api/reassessment/sensitive-sites'

export const requestGetSensitiveSites = ({
  // eslint-disable-next-line no-magic-numbers
  resultsPerPage = 12,
  // eslint-disable-next-line no-magic-numbers
  currentPage = 1,
  sortBy = 'siteCode',
  sortDirection = 'ASC',
  proposalPurpose,
  taxonId,
  signal,
  ...rest
}) => {
  const queryString = {
    resultsPerPage,
    currentPage,
    sortBy,
    sortDirection,
    ...(proposalPurpose == null ? {} : { proposalPurpose }),
    ...(taxonId != null && taxonId !== '' ? { taxonId } : {}),
    ...rest
  }

  const queryStringParsed = qs.stringify(queryString)

  return getRequest(`${path}?${queryStringParsed}`, signal)
}

export const requestApproveSensitiveSite = (siteHistoryId, viewerId, sensitiveSpeciesRequestType) => {
  return postRequest(`${path}/${siteHistoryId}/approve`, {
    viewerId,
    sensitiveSpeciesRequestType
  })
}

export const requestRejectSensitiveSite = (siteHistoryId, viewerId, sensitiveSpeciesRequestType) => {
  return postRequest(`${path}/${siteHistoryId}/reject`, {
    viewerId,
    sensitiveSpeciesRequestType
  })
}

